import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { globalServices } from "../../../Services/global.service";
import { storeService } from "../../../Services/store.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import Tooltip from "../../../Components/Common/Tooltip";
import * as dateHelper from "../../../Helpers/DateHelper";
import Select from "react-select";
import { posServices } from "../../../Services";
import { invoiceCashBalanceServices } from "../../../Services/PDFservice/invoicecashbalance.service";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AuthContext } from "../../../Contexts/AuthContext";
import AsyncSelect from "react-select/async";

import XLSX from "xlsx";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();

  const { userId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [posTag, setPosTag] = useState([]);
  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    date: new Date(),
  });

  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    posTag: "",
    storeTag: "",
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  useEffect(() => {
    updateLocName("invoices-cash-balance");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);
    posServices
      .invoicePos({
        tenantId: Number(search.tenantId),
        storeTag: search.storeTag,
        posTag: search.posTag,
        pageIndex: search.pageIndex,
        pageSize: search.pageSize,
      })
      .then((res) => {
        setReports(
          res.data.data.map((p) => {
            return {
              ...p,
              issued: dateHelper.formatUtcToDate(p.issued),
            };
          })
        );
        setPagination({
          ...pagination,
          totalCount: res.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    document.getElementById("actions").style.display = "none";
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "paymentMethodName",
      text: translator("InvCashBalance-PayMethod"),
      headerStyle: () => {
        if (isMobile) return { width: "150px", textAlign: "left" };
      },
      style: () => {
        if (isMobile) return { width: "150px", textAlign: "left" };
      },
    },
    {
      dataField: "amount",
      text: translator("InvCashBalance-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "50%", textAlign: "right" };
      },
      style: () => {
        return { width: "50%", textAlign: "right" };
      },
    },
  ];

  const exportFunction = () => {
    posServices
      .invoicePos({
        tenantId: Number(search.tenantId),
        storeTag: search.storeTag,
        posTag: search.posTag,
        pageIndex: search.pageIndex,
        pageSize: 0,
      })
      .then((res) => {
        invoiceCashBalanceServices.handlePrint(
          res.data.data,
          reportTag,
          translator
        );
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportExcelFunction = () => {
    posServices
      .invoicePos({
        tenantId: Number(search.tenantId),
        storeTag: search.storeTag,
        posTag: search.posTag,
        pageIndex: search.pageIndex,
        pageSize: 0,
      })
      .then((res) => {
        // File name
        var ws_name = `${translator("InvoiceCashBalancePDF-CashBalance")}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
          [translator("InvoiceCashBalancePDF-Date"), reportTag.date],
          [
            translator("InvoiceCashBalancePDF-PayMethod"),
            translator("InvoiceCashBalancePDF-Amount"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res.data.data.map((x) => {
          const array = [x.paymentMethodName, x.amount];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [{ width: 20 }, { width: 20 }];
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, ws_name);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("CashBalanceReport-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>

                    <Controller
                      as={AsyncSelect}
                      control={control}
                      autoComplete="off"
                      name="tenantId"
                      placeholder={translator("Select-Tenant")}
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeTag", null);
                        setValue("posTag", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });
                        getStores(event[0].id);
                        //setReports([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                <Tooltip text={translator("StoreTagTooltip-Msg")} />
                <Controller
                  as={Select}
                  control={control}
                  autoComplete="off"
                  name="storeTag"
                  placeholder={translator("SelectStoreTag")}
                  rules={{ required: true }}
                  onChange={function (event) {
                    setValue("posTag", null);
                    setSearch({
                      ...search,
                      storeTag: event[0].label,
                    });
                    setReportTag({
                      ...reportTag,
                      storeName: event[0].label,
                    });
                    getPos(event[0].id);

                    //setReports([]);

                    return event[0];
                  }}
                  options={
                    storesTag &&
                    storesTag.map((e) => ({
                      id: e.id,
                      label: e.tag,
                      value: e.name,
                    }))
                  }
                />
                {errors.storeTag && errors.storeTag.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                    <Tooltip text={translator("PosTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="posTag"
                      rules={{ required: true }}
                      onChange={function (event) {
                        setSearch({
                          ...search,
                          posTag: event[0].value,
                        });
                        setReportTag({
                          ...reportTag,
                          posName: event[0].label,
                        });
                        //setReports([]);

                        return event[0];
                      }}
                      options={
                        posTag &&
                        posTag.map((e) => ({
                          id: e.id,
                          label: e.tag + " - ( " + e.inventoryNumber+" )",
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.posTag && errors.posTag.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <>
              <button
                className="btn btn-outline-secondary "
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
